"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDay = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'week-day';
const weekdaysTranslations = {
    1: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Mon', defaultMessage: 'Mon' })),
    2: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Tue', defaultMessage: 'Tue' })),
    3: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Wed', defaultMessage: 'Wed' })),
    4: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Thu', defaultMessage: 'Thu' })),
    5: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Fri', defaultMessage: 'Fri' })),
    6: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Sat', defaultMessage: 'Sat' })),
    7: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/WeekDay:Sun', defaultMessage: 'Sun' })),
};
const WeekDay = (props) => {
    const { name, modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const weekday = name.isoWeekday();
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__name` }, weekdaysTranslations[weekday])));
};
exports.WeekDay = WeekDay;
//# sourceMappingURL=index.js.map